import { render } from "./readyKitchenModel.vue?vue&type=template&id=634aa8d2"
import script from "./readyKitchenModel.vue?vue&type=script&lang=js"
export * from "./readyKitchenModel.vue?vue&type=script&lang=js"

import "./readyKitchenModel.vue?vue&type=style&index=0&id=634aa8d2&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__